import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

interface Props {
  open: boolean;
  handleClose: (status: boolean) => void;
  handleConfirm: () => void;
}

const KiteDisconnectConfirmation: React.FC<Props> = ({ open, handleClose, handleConfirm }) => {
  const handleCancel = () => handleClose(false);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="kite-confirmation-title"
      aria-describedby="kite-confirmation-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <PowerSettingsNewIcon />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              Confirm Disconnect
            </Typography>
            <Typography align="center">Are you sure you want to disconnect from Kite Connect?</Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
            <Button fullWidth onClick={handleCancel} color="secondary" variant="outlined">
              Cancel
            </Button>
            <Button fullWidth color="primary" variant="contained" onClick={handleConfirm} autoFocus>
              Yes
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default KiteDisconnectConfirmation;
